module.exports = __webpack_public_path__ + "static/events_cta_hero-b964aa29100c5d5a063703fbdb8c5afc.png";